import Vue from 'vue';
import AcaciaPlugin from '@acacia_consultoria/vue-acacia-plugin';
import VuetifyColors from 'vuetify/es5/util/colors';

import App from './App';
import store from './store';
import router from './router';

import '../node_modules/vuetify/dist/vuetify.min.css';

Vue.config.productionTip = false;
Vue.use(AcaciaPlugin, {
  theme: {
    primary: VuetifyColors.blueGrey.base,
    secondary: VuetifyColors.blueGrey.darken2,
    accent: VuetifyColors.deepOrange.base,
    error: VuetifyColors.red.base,
    warning: VuetifyColors.yellow.base,
    info: VuetifyColors.lightBlue.base,
    success: VuetifyColors.green.base,
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  beforeCreate() {
    this.$store.dispatch('Acacia/Start', ['auth']).then(() => {
      const { redirect } = this.$route.query;
      if (redirect) this.$router.replace(redirect);
    });
  },
});



// WEBPACK FOOTER //
// ./src/main.js